<template>
	<div class="otherBox">
		<div class="column">
			<div class="columnText2">
				发票须知
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.invoiceExplain" class="columnText3" style="flex: 1;text-align: center;"
				placeholder="请输入发票须知" type="text"></el-input>
		</div>
		<div class="column">
			<div class="columnText2">
				其它须知
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.otherExplain" class="columnText3" style="flex: 1;text-align: center;"
				placeholder="请输入其他须知" type="text"></el-input>
		</div>
		<div class="column">
			<div class="columnText2">
				安全须知
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.securityExplain" class="columnText3" style="flex: 1;text-align: center;"
				placeholder="请输入安全须知" type="text"></el-input>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		datas: {
			type: Object,
			default: {}
		},
		disabled: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {

		}
	},
	methods: {

	}
}
</script>
<style lang="scss" scoped>
/deep/ .el-input__inner {
	text-align: center;
}
.otherBox {
	border-radius: 0.05rem;
	background-color: rgba(250, 250, 250, 1);
	padding: 0 0.1rem;

	.column {
		height: 0.4rem;
		border-top: 1px dotted #E9E9E9;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:nth-child(1) {
			border-top: none;
			height: 70rpx;
		}

		.columnText2 {
			color: rgba(149, 144, 144, 1);
			text-align: center;
			margin-right: 0.15rem;
		}

		.columnText3 {
			color: #000000;
			text-align: center;
		}

		.columnText4 {
			color: rgba(230, 74, 25, 1);
			text-align: center;
		}

		.columnText1 {
			color: #000000;
			font-size: 0.15rem;
			text-align: center;
		}
	}
}
</style>
